import React, { useMemo, createContext, useContext, useCallback } from 'react';
import { NotificationContainer, NotificationManager } from "react-notifications";



export const NotificationContext = createContext();

export const NotificationContextProvider = ({ children }) => {

  const showSuccess = useCallback(({ title, content, timeout, event }) => {
    NotificationManager.success(content || '', title || 'Success', timeout || 3000, event ? event : null);
  }, []);

  const showWarning = useCallback(({ title, content, timeout, event }) => {
    NotificationManager.warning(content || '', title || 'Warning', timeout || 3000, event ? event : null);
  }, []);

  const showError = useCallback(({ title, content, timeout, event }) => {
    NotificationManager.error(content || '', title || 'Error', timeout || 3000, event ? event : null);
  }, []);

  const value = useMemo(() => {
    return {
      showSuccess,
      showWarning,
      showError,
    };
  }, [showSuccess, showWarning, showError]);


  return (
    <NotificationContext.Provider value={value}>

      {children}
      <NotificationContainer />

    </NotificationContext.Provider>
  );
};

export function useNotification() {
  return useContext(NotificationContext);
}
